<template>
  <form>
    <!-- BEGIN USERNAME -->
    <div class="field">
      <label class="label" for="username">{{$t('username', 'Username')}} *</label>
      <div class="control">
        <input
          :disabled="existingUser && existingUser.username"
          :readonly="existingUser && existingUser.username"
          class="input"
          :class="errors.username && 'is-danger'"
          type="text"
          id="username"
          v-model="user.username"
        >
      </div>
      <template>
        <p v-for="error in errors.username" :key="error" class="is-danger help">{{ error }}</p>
      </template>
    </div>
    <!-- END USERNAME -->
    <!-- BEGIN PASSWORD -->
    <div class="field">
      <label class="label" for="password">
        <span v-if="existingUser">{{$t('new-password', 'New password')}}</span>
        <span v-else>{{$t('password', 'Password')}} *</span>
      </label>
      <div class="control">
        <input class="input" :class="errors.password && 'is-danger'" type="password" id="password" v-model="password">
      </div>
      <template>
        <p v-for="error in errors.password" :key="error" class="is-danger help">{{ error }}</p>
      </template>
    </div>
    <!-- END PASSWORD -->
    <!-- BEGIN CONFIRM PASSWORD -->
    <div class="field">
      <label class="label" for="confirm-password">
        <span v-if="existingUser">{{$t('confirm-new-password', 'Confirm new password')}}</span>
        <span v-else>{{$t('confirm-password', 'Confirm password')}} *</span>
      </label>
      <div class="control">
        <input class="input" :class="errors.confirmPassword && 'is-danger'" type="password" id="confirm-password" v-model="confirmPassword">
      </div>
      <template>
        <p v-for="error in errors.confirmPassword" :key="error" class="is-danger help">{{ error }}</p>
      </template>
    </div>
    <!-- END CONFIRM PASSWORD -->
    <!-- BEGIN ROLE -->
    <div class="field">
      <label class="label" for="role">{{$t('role', 'Role')}}</label>
      <div class="control">
        <div class="select">
          <select name="role" id="role" v-model="user.role">
            <option value="User">{{$t('user', 'User')}}</option>
            <option value="Administrator">{{$t('administrator', 'Administrator')}}</option>
          </select>
        </div>
      </div>
    </div>
    <!-- END ROLE -->
    <div v-if="showSubmit" class="field">
      <button type="submit" class="button is-primary" @click.prevent="submitUser">{{$t('submit', 'Submit')}}</button>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    existingUser: { type: Object, default: undefined },
    showSubmit: { type: Boolean, default: false }
  },
  data () {
    return {
      user: Object.assign({}, { role: 'User' }, this.existingUser),
      password: null,
      confirmPassword: null,
      errors: {}
    }
  },
  methods: {
    validateForm () {
      this.errors = {}

      if (!this.user.username) {
        this.errors.username = [
          this.$t('is-required', {
            replace: { field: this.$t('username', 'Username') },
            defaultValue: 'Username is required'
          })
        ]
      }

      if (!this.existingUser || this.password || this.confirmPassword) {
        if (!this.password) {
          this.errors.password = [
            this.$t('is-required', {
              replace: { field: this.$t('password', 'Password') },
              defaultValue: 'Password is required'
            })
          ]
        }

        if (!this.confirmPassword) {
          this.errors.confirmPassword = [
            this.$t('is-required', {
              replace: { field: this.$t('password', 'Password') },
              defaultValue: 'Password is required'
            })
          ]
        }

        if (this.password !== this.confirmPassword) {
          this.errors.password = [this.$t('passwords-must-match', 'Passwords must match')]
          this.errors.confirmPassword = [this.$t('passwords-must-match', 'Passwords must match')]
        }
      }

      return Object.keys(this.errors).length === 0
    },
    submitUser () {
      if (this.validateForm()) {
        this.$emit('onSubmitUser', {
          id: this.user.id,
          username: this.user.username,
          password: this.password,
          confirmPassword: this.confirmPassword,
          role: this.user.role
        })
      }
    }
  }
}
</script>
